import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from "prop-types";
import React, { Component } from "react";
import { getRehydratableName, getClassNameFactory } from "../../utilities";
import classNames from "classnames";
import CrossIcon from "@dcl/icons/esm/ui/cross";
import SearchIcon from "@dcl/icons/esm/ui/search";
import TypeaheadItem from "./components/TypeaheadItem";
import Alert from "../Alert/Alert";
import { AlertState } from "../Alert/AlertTypes";
import queryString from "query-string";
import fetchJsonp from "fetch-jsonp";
import debounce from "lodash/debounce";
import uniqueId from "lodash/uniqueId";
import isEqual from "lodash/isEqual";

var getRandomInt = function getRandomInt(minFloat, maxFloat) {
  var min = Math.ceil(minFloat);
  var max = Math.floor(maxFloat);
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

var SearchInput = /*#__PURE__*/function (_Component) {
  _inherits(SearchInput, _Component);

  var _super = _createSuper(SearchInput);

  /* eslint-disable max-len */

  /* eslint-enable max-len */
  function SearchInput(props) {
    var _this;

    _classCallCheck(this, SearchInput);

    _this = _super.call(this, props);
    _this.getClassName = getClassNameFactory(SearchInput.displayName);
    _this.input = null;
    _this.submitButton = null;
    _this.state = {
      userQuery: _this.props.value,
      query: _this.props.value,
      searchSuggestions: _this.props.searchSuggestions || [],
      selectedSuggestion: null,
      inputError: null,
      suggestionsAlert: ""
    };
    var searchSuggestionDebounceTimeout = 100;
    _this.getSearchSuggestionsDebounced = debounce(_this.getSearchSuggestions, searchSuggestionDebounceTimeout);
    _this.id = uniqueId("searchInput-");
    var cacheBustMin = 1;
    var cacheBustMax = 999999999999; // We only bust cache once per component, rather than with every request.

    _this.cacheBust = getRandomInt(cacheBustMin, cacheBustMax); // get value between 1 and 999999999999

    return _this;
  }

  _createClass(SearchInput, [{
    key: "buildTypeaheadUrl",
    value: function buildTypeaheadUrl(query) {
      var _this$props$typeahead = this.props.typeaheadUrl.split("?"),
          _this$props$typeahead2 = _slicedToArray(_this$props$typeahead, 2),
          cleanUrl = _this$props$typeahead2[0],
          existingQs = _this$props$typeahead2[1];

      var requestParams = _objectSpread(_objectSpread({
        max_results: 7,
        // eslint-disable-line camelcase
        beginning: 1
      }, queryString.parse(existingQs)), {}, {
        query: query,
        _: this.cacheBust
      });

      return "".concat(cleanUrl, "?").concat(queryString.stringify(requestParams));
    }
  }, {
    key: "getSearchSuggestions",
    value: function getSearchSuggestions(query) {
      var _this2 = this;

      return fetchJsonp(this.buildTypeaheadUrl(query)).then(function (response) {
        return response.json();
      }).then(function (data) {
        _this2.setState({
          searchSuggestions: data,
          selectedSuggestion: null
        });
      });
    }
  }, {
    key: "focusAppropriateSuggestion",
    value: function focusAppropriateSuggestion(e) {
      var _this$state$searchSug;

      var hasSuggestions = ((_this$state$searchSug = this.state.searchSuggestions) === null || _this$state$searchSug === void 0 ? void 0 : _this$state$searchSug.length) > 0;
      var selectedSuggestion = hasSuggestions ? this.state.selectedSuggestion : null;

      if (e.key === "ArrowDown" && hasSuggestions) {
        if (selectedSuggestion === null) {
          selectedSuggestion = 0;
        } else if (selectedSuggestion < this.state.searchSuggestions.length - 1) {
          selectedSuggestion = selectedSuggestion + 1;
        }
      } else if (e.key === "ArrowUp") {
        selectedSuggestion = selectedSuggestion > 0 ? selectedSuggestion - 1 : null;
      }

      var currentElement = this.ref.querySelector("#".concat(this.id, "-typeaheadItem-").concat(selectedSuggestion, " button"));

      if (currentElement) {
        currentElement.scrollIntoView({
          block: "nearest"
        });
      }

      this.setState({
        query: selectedSuggestion === null ? this.state.userQuery : this.state.searchSuggestions[selectedSuggestion],
        selectedSuggestion: selectedSuggestion
      });
    }
  }, {
    key: "reset",
    value: function reset() {
      this.setState({
        userQuery: "",
        query: "",
        searchSuggestions: [],
        selectedSuggestion: null
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.value !== this.props.value) {
        this.setState({
          userQuery: this.props.value,
          query: this.props.value
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.suggestionsAlertTimeout);
    }
  }, {
    key: "handleClearClick",
    value: function handleClearClick(e) {
      e.preventDefault();
      var _this$props = this.props,
          onChange = _this$props.onChange,
          onClear = _this$props.onClear;
      this.reset(); // Retain focus

      this.input.focus();
      this.setState({
        inputError: null
      });

      if (onChange) {
        onChange("");
      }

      if (onClear) {
        onClear();
      }
    }
  }, {
    key: "handleInputChange",
    value: function handleInputChange(e) {
      var _this3 = this;

      var _this$props2 = this.props,
          onChange = _this$props2.onChange,
          validate = _this$props2.validate;
      var suggestedValueMinLength = 2;

      if (this.suggestionsAlertTimeout) {
        clearTimeout(this.suggestionsAlertTimeout);
        this.setState({
          suggestionsAlert: ""
        });
      }

      var inputValue = e.target.value;

      if (validate && inputValue !== "") {
        var inputError = validate(inputValue);

        if (inputError || inputError === null) {
          this.setState({
            inputError: inputError
          });
          return;
        }
      }

      var hasQuery = inputValue.length > 1;
      this.setState({
        query: inputValue,
        userQuery: inputValue,
        searchSuggestions: hasQuery ? this.state.searchSuggestions : [],
        inputError: null
      });

      if (hasQuery && this.props.typeahead && this.props.typeaheadUrl) {
        this.getSearchSuggestionsDebounced(inputValue);
      }

      if (onChange) {
        onChange(inputValue);
      }

      var interval = 1000;

      if (inputValue.length > suggestedValueMinLength && this.props.typeahead) {
        this.suggestionsAlertTimeout = setTimeout(function () {
          _this3.setState({
            suggestionsAlert: "".concat(_this3.state.searchSuggestions.length, " search results suggested")
          });
        }, interval);
      }
    }
  }, {
    key: "handleSearchSubmit",
    value: function handleSearchSubmit(e) {
      if (this.state.query === "" && !this.props.allowEmptyInput) {
        e.preventDefault();
        this.input.focus();
      } else if (this.props.onSubmit) {
        e.preventDefault();
        this.props.onSubmit(this.state.query);
      }

      this.setState({
        searchSuggestions: []
      });
    }
  }, {
    key: "handleEscape",
    value: function handleEscape(e) {
      e.preventDefault();

      if (this.state.searchSuggestions.length > 0) {
        if (this.props.onBlur) {
          this.props.onBlur(e);
        }

        this.setState({
          searchSuggestions: [],
          query: this.state.userQuery
        });
      } else {
        this.input.blur();
      }
    }
  }, {
    key: "handleInputKeyDown",
    value: function handleInputKeyDown(e) {
      if (e.key === "Enter" && this.props.onSubmit) {
        this.handleSearchSubmit(e);
      } else if (e.key === "ArrowDown" || e.key === "ArrowUp") {
        e.preventDefault();
        this.focusAppropriateSuggestion(e);
      } else if (e.key === "Escape") {
        this.handleEscape(e);
      }
    }
  }, {
    key: "handleSuggestionClick",
    value: function handleSuggestionClick(e) {
      var _this4 = this;

      // Although this is a submit event, native form submissions rely on the
      // state being up to date. setState happens asynchronously, but event
      // callbacks happen synchronously. In order to support both JS and native
      // form submissions in this scenario, we use an escape hatch by
      // programatically firing a click event on the submit button after the state
      // has updated.
      e.preventDefault();
      this.setState({
        query: e.currentTarget.value
      }, function () {
        return _this4.submitButton.click();
      });
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(e) {
      // document.activeElement is IE11 fallback
      var relatedTarget = e.relatedTarget || document.activeElement;

      if (this.ref && relatedTarget && this.ref.contains(relatedTarget)) {
        return;
      }

      this.setState({
        searchSuggestions: []
      });

      if (this.props.onBlur) {
        this.props.onBlur(e);
      }

      if (this.props.restoreValueOnBlur) {
        this.setState({
          query: this.props.value,
          userQuery: this.props.value
        });
      }
    }
  }, {
    key: "handleRef",
    value: function handleRef(ref) {
      this.ref = ref;
    }
  }, {
    key: "handleCantFindMyAddressClick",
    value: function handleCantFindMyAddressClick(e) {
      e.preventDefault();
      this.props.onCantFindMyAddressClick();
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      return /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          states: classNames({
            expanded: this.state.searchSuggestions.length > 0 || this.props.showCantFindYourAddressSuggestion && this.state.query.length > 2,

            /** this condition is to check if search input is in Address validation component and there is no suggestion and only can't fid my address is present*/
            active: this.state.query !== ""
          }),
          modifiers: classNames({
            dark: this.props.colorTheme === "dark",
            orange: this.props.colorTheme === "orange",
            narrow: this.props.isNarrow,
            disabled: this.props.disabled
          })
        }),
        ref: this.handleRef.bind(this),
        onBlur: this.handleBlur.bind(this),
        "data-auto-focus": JSON.stringify(this.props.autoFocus),
        "data-color-theme": JSON.stringify(this.props.colorTheme),
        "data-name": JSON.stringify(this.props.name),
        "data-placeholder": JSON.stringify(this.props.placeholder),
        "data-rehydratable": getRehydratableName(SearchInput.displayName),
        "data-typeahead": JSON.stringify(this.props.typeahead),
        "data-typeahead-url": JSON.stringify(this.props.typeaheadUrl),
        "data-search-label": JSON.stringify(this.props.searchLabel),
        "data-value": JSON.stringify(this.props.value),
        tabIndex: "-1"
      }, /*#__PURE__*/React.createElement("label", {
        className: this.getClassName({
          descendantName: "label",
          utilities: "hiddenVisually"
        }),
        htmlFor: this.id
      }, this.props.searchLabel || SearchInput.defaultProps.searchLabel), /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          descendantName: "box"
        })
      }, this.props.displaySearchIcon && /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          descendantName: "searchIcon"
        })
      }, /*#__PURE__*/React.createElement(SearchIcon, null)), /*#__PURE__*/React.createElement("input", _extends({
        // some of aria attributes are disabled based on this.props.typeahead - otherwise it causes screenreaders to falsely read them
        // disabling the line below, autoFocus is a prop of this component jsx-a11y/no-autofocus
        autoFocus: this.props.autoFocus,
        className: this.getClassName({
          descendantName: "input"
        }),
        autoComplete: this.props.autoComplete,
        placeholder: this.props.placeholder,
        id: this.id,
        onChange: this.handleInputChange.bind(this),
        onKeyDown: this.handleInputKeyDown.bind(this),
        ref: this.props.innerRef || function (ref) {
          _this5.input = ref;
        },
        type: "search",
        value: this.state.query,
        name: this.props.name,
        "aria-haspopup": this.props.typeahead ? "true" : undefined,
        "aria-owns": this.props.typeahead ? "".concat(this.id, "-typeahead") : undefined,
        "aria-invalid": this.props.hasError,
        "aria-expanded": this.props.typeahead ? this.state.query === "" ? "false" : "true" : undefined,
        "aria-autocomplete": this.props.typeahead ? "both" : undefined // disabling the line below, aria is valid jsx-a11y/role-has-required-aria-props
        ,
        role: this.props.typeahead ? "combobox" : undefined,
        disabled: this.props.disabled
      }, this.state.selectedSuggestion === null ? {} : {
        "aria-activedescendant": "".concat(this.id, "-typeaheadItem-").concat(this.state.selectedSuggestion)
      })), this.state.inputError && /*#__PURE__*/React.createElement(Alert, {
        alertState: AlertState.FAILURE
      }, this.state.inputError), /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          descendantName: "buttons"
        })
      }, /*#__PURE__*/React.createElement("button", {
        "aria-label": this.props.clearSearchLabel,
        className: this.getClassName({
          descendantName: "clearButton"
        }),
        onClick: this.handleClearClick.bind(this),
        type: "button"
      }, /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          descendantName: "icon"
        })
      }, /*#__PURE__*/React.createElement(CrossIcon, null))), /*#__PURE__*/React.createElement("button", {
        "aria-label": this.props.submitSearchLabel,
        className: this.getClassName({
          descendantName: "searchButton"
        }),
        onClick: this.handleSearchSubmit.bind(this),
        type: "submit",
        ref: function ref(_ref) {
          return _this5.submitButton = _ref;
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          descendantName: "icon"
        })
      }, /*#__PURE__*/React.createElement(SearchIcon, null))))), this.props.typeahead ? /*#__PURE__*/React.createElement("span", {
        className: this.getClassName({
          descendantName: "suggestionsAlert",
          utilities: "hiddenVisually"
        }),
        "aria-live": "polite",
        "aria-atomic": "true"
      }, this.state.suggestionsAlert) : null, /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          descendantName: "typeahead"
        }),
        tabIndex: "-1"
      }, /*#__PURE__*/React.createElement("ul", {
        className: this.getClassName({
          descendantName: "typeaheadItems"
        }),
        id: "".concat(this.id, "-typeahead"),
        role: "listbox"
      }, this.state.searchSuggestions.map(function (suggestion, i) {
        return /*#__PURE__*/React.createElement(TypeaheadItem, {
          colorTheme: _this5.props.colorTheme,
          highlight: _this5.state.userQuery,
          id: "".concat(_this5.id, "-typeaheadItem-").concat(i),
          key: i,
          onClick: _this5.handleSuggestionClick.bind(_this5),
          selected: _this5.state.selectedSuggestion === i,
          value: suggestion,
          disableRegexPattern: _this5.props.disableRegexPattern,
          allowedRegexExpression: _this5.props.allowedRegexExpression
        });
      })), this.props.showCantFindYourAddressSuggestion && /*#__PURE__*/React.createElement("button", {
        className: this.getClassName({
          descendantName: "cantFindAddressButton"
        }),
        onClick: this.handleCantFindMyAddressClick.bind(this)
      }, this.props.cantFindYourAddressLabel)));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (!nextProps.searchSuggestions) {
        return {
          searchSuggestions: prevState.searchSuggestions
        };
      }

      if (!isEqual(prevState.searchSuggestions, nextProps.searchSuggestions)) {
        return {
          searchSuggestions: nextProps.searchSuggestions
        };
      }

      return null;
    }
  }]);

  return SearchInput;
}(Component);

_defineProperty(SearchInput, "displayName", "SearchInput");

_defineProperty(SearchInput, "propTypes", {
  /**
   * Used for managing suggestions from outside.
   */
  searchSuggestions: PropTypes.array,

  /**
   * Whether this search input should have focus on page load. Note that only one input can have `autoFocus` set on a page.
   */
  autoFocus: PropTypes.bool,

  /**
   * Color theme of the search input.
   */
  colorTheme: PropTypes.oneOf(["light", "dark", "orange"]),

  /**
   * Blur callback.
   */
  onBlur: PropTypes.func,

  /**
   * Submission callback. Prevents default form submit if specified.
   */
  onSubmit: PropTypes.func,

  /**
   * Autocomplete specifies whether this search input should have Browser saved suggestions based on earlier typed values.
   */
  autoComplete: PropTypes.string,

  /**
   * Name of the input, used for form submission. Must be unique to form.
   */
  name: PropTypes.string,

  /**
   * Placeholder text.
   */
  placeholder: PropTypes.string,

  /**
   * Use typeahead for search suggestions.
   */
  typeahead: PropTypes.bool,

  /**
   * JSONP URL for typeahead. Required if `typeahead = true`.
   */
  typeaheadUrl: PropTypes.string,

  /**
   * Value for the input. Overrides internal value if updated.
   */
  value: PropTypes.string,

  /**
   * Flag which allows to trigger onSubmit event with empty string
   */
  allowEmptyInput: PropTypes.bool,

  /**
   * Flag which indicate that need to use value from props after blur
   */
  restoreValueOnBlur: PropTypes.bool,

  /**
   * An optional prop to pass label value
   */
  searchLabel: PropTypes.string,

  /**
   * Clear search button label (optional)
   */
  clearSearchLabel: PropTypes.string,

  /**
   * Submit search button label (optional)
   */
  submitSearchLabel: PropTypes.string,

  /**
   * Forwarded ref to manage focus
   */
  innerRef: PropTypes.any,

  /**
   * Optional prop for rendering narrow input
   */
  isNarrow: PropTypes.bool,

  /**
   * Optional prop for disabled state
   */
  disabled: PropTypes.bool,

  /**
   * Optional prop for handling onChange event
   */
  onChange: PropTypes.func,

  /**
   * Optional prop for validating user input
   */
  validate: PropTypes.func,

  /**
   * Optional prop for handling Clear button click
   */
  onClear: PropTypes.func,

  /**
   * Optional prop for aria-invalid
   */
  hasError: PropTypes.any,

  /**
   * Optional prop disabling regex. we will allow only numbers and letters in user query. If false will not add any changes.
   */
  disableRegexPattern: PropTypes.bool,

  /**
   * Optional prop to pass regex pattern to allow only letters and numbers.
   */
  allowedRegexExpression: PropTypes.string,

  /**
   * Optional prop for handling Can't find my address click.
   */
  onCantFindMyAddressClick: PropTypes.func,

  /**
   * Can't find my address Label (Optional).
   */
  cantFindYourAddressLabel: PropTypes.string,

  /**
   * Identifier to show Can't find my address button (Optional).
   */
  showCantFindYourAddressSuggestion: PropTypes.bool,

  /**
   * Optional prop to show search icon.
   */
  displaySearchIcon: PropTypes.bool
});

_defineProperty(SearchInput, "defaultProps", {
  autoFocus: false,
  colorTheme: "light",
  name: "q",
  placeholder: "Search",
  typeahead: true,
  typeaheadUrl: "",
  value: "",
  autoComplete: "off",
  allowEmptyInput: false,
  restoreValueOnBlur: false,
  searchLabel: "Search. Autosuggestions will show up with 3 or more characters",
  clearSearchLabel: "Clear search",
  submitSearchLabel: "Submit search",
  isNarrow: false,
  disabled: false,
  hasError: "",
  // should be empty if no prop available
  disableRegexPattern: false,
  // this props is true then we will allow only numbers and letters in user query. If false will not add any changes.
  allowedRegexExpression: "[^a-zA-Z0-9s]",
  // regex to allow only numbers and letters.
  showCantFindYourAddressSuggestion: false,
  cantFindYourAddressLabel: "Can't find your address?",
  displaySearchIcon: false
});

export default SearchInput;